import { getNextBracketedExpression } from 'casetivity-shared-js/lib/spel/getFieldsInAst/getSelectionExpression';
import { evaluateExpression } from 'casetivity-shared-js/lib/spel/evaluate';
import { identity } from 'fp-ts/lib/function';

export const evaluateFilterString = (
    filterString: string,
    context: {},
    sanitizeResult: (result: string) => string = identity,
) => {
    const parse = getNextBracketedExpression({
        bracketClosesOn: ']',
        bracketNaivelyOpensOn: '[',
        bracketOpensOn: '$[',
    });
    const evalString = (str: string) =>
        parse(str).fold(str, ({ before, inner, after }) => {
            const result = evaluateExpression(inner, context);
            const sanitizedResult = sanitizeResult(result ? result.toString() : '');
            return `${before}${sanitizedResult}${evalString(after)}`;
        });
    return evalString(filterString);
};

export const applyToFilterString = (filterString: string, items: string[]) => {
    const parse = getNextBracketedExpression({
        bracketClosesOn: ']',
        bracketNaivelyOpensOn: '[',
        bracketOpensOn: '$[',
    });
    let i = 0;
    const evalString = (str: string) =>
        parse(str).fold(str, ({ before, inner, after }) => {
            const result: string = `${before}${items[i]}${evalString(after)}`;
            i += 1;
            return result;
        });
    return evalString(filterString);
};
